<template>
  <div id="askAnExpert">
    <div class="contents-container">
      <top-nav :show-user="true" />
      <div class="content">
        <div class="row">
          <div class="col s12">
            <div class="section-title">
              Ask an Expert
            </div>
            <div class="description">
              <p>
                Are you having trouble completing your Climate Change Home Risk
                Assessment and figuring out the best adaptation or mitigation
                options for your home? Do not worry – we have a team of
                volunteer experts, including local engineers, architects and
                construction professionals standing by to help guide you through
                the process. Using the form below, you can pose a question to an
                expert and a response will be provided to the email address you
                provide in the form. Provide sufficient background information
                and make your question(s) as specific as possible so our experts
                can provide you the best response.
              </p>
              <p>
                Remember, experts do not have access to your Assessment or Plan,
                so they will only receive the information you provide. You can
                attach photos of your home to help experts understand your
                question or the circumstances of your home better. Include your
                phone number in your request so an expert can call you to
                discuss your question if they prefer.
              </p>
            </div>
            <div class="card grey lighten-3 z-depth-0">
              <div class="card-content">
                Please note that while experts are provided to support you by
                answering key questions, you should not except them to complete
                your Assessment or develop your Adaptation Plan. Before asking
                an expert, check out the resources provided in the
                <em>Act to Adapt </em>
                <router-link :to="{ name: 'resourceCenter' }"
                  >Resource Centre
                </router-link>
                - you may find the answer to your question there!
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col s12 input-field">
            <div class="label">Student Name</div>
            <input
              name="student_name"
              id="student_name"
              type="text"
              v-model="form.name"
            />
          </div>
          <!--  -->
          <div class="col s12 m6 input-field">
            <div class="label">School</div>
            <select
              v-model="form.school"
              name="secondaySchool"
              id="secondaySchool"
              class="browser-default"
            >
              <option value="0" selected> Select seconday school</option>
              <option
                :value="s"
                v-for="(s, i) in schools"
                :key="i"
                v-html="s"
              ></option>
            </select>
            <div
              class="input-field col s12 no-padding"
              v-if="form.school === 'Other'"
            >
              <input
                type="text"
                placeholder="Enter school name "
                v-model="form.school_other"
              />
            </div>
          </div>
          <!--  -->
          <div class="col s12 m6 input-field">
            <div class="label">Email Address</div>
            <input
              :disabled="true"
              type="email"
              name="email"
              id="email"
              v-model="form.email"
            />
          </div>
          <!--  -->
          <div class="col s12 m6 input-field">
            <div class="label">Contact Number</div>
            <input
              type="tel"
              name="contact_number"
              id="contact_number"
              v-model="form.contact_number"
            />
          </div>
          <!--  -->
          <div class="col s12 input-field">
            <div class="label">What do you need help with?</div>
            <p v-for="(x, i) in yourNeed" :key="i">
              <label>
                <input
                  type="checkbox"
                  :value="x.value"
                  group="reason"
                  v-model="form.help_reason"
                />
                <span v-html="x.label"></span>
              </label>
            </p>
          </div>
          <!--  -->
          <div class="col s12 input-field">
            <div class="question">
              If you need help with the Climate Change Home Risk Assessment,
              check the box for the relevant section of the Assessment below and
              pose your question(s) in the space provided.
            </div>
            <div class="check-box-inputs">
              <div
                class="list-wrapper"
                v-for="(o, k) in home_risk_assessment"
                :key="k + 1 * 0.99"
              >
                <p>
                  <label>
                    <input
                      type="checkbox"
                      :value="o.value"
                      group="reason"
                      v-model="o.display"
                    />
                    <span v-html="o.label"></span>
                  </label>
                </p>
                <div class="spacer-divider"></div>
                <textarea
                  v-if="o.display"
                  class="materialize-textarea"
                  v-model="form.risk_assessment[o.key]"
                ></textarea>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col s12 input-field">
            <div class="question">
              If you need help with your Adaptation Plan, check the box that
              relates to the priority areas you have identified for adaptation
              projects (or mitigation measures, in the case of your carbon
              footprint) and pose your question(s) in the space provided.
            </div>
            <div
              class="list-wrapper"
              v-for="(o, k) in adaptation_plan"
              :key="k + 1 * 0.99"
            >
              <p>
                <label>
                  <input
                    type="checkbox"
                    :value="o.value"
                    group="reason"
                    v-model="o.display"
                  />
                  <span v-html="o.label"></span>
                </label>
              </p>
              <div class="spacer-divider"></div>
              <textarea
                v-if="o.display"
                class="materialize-textarea"
                v-model="form.adaptation_plan[o.key]"
              ></textarea>
            </div>
          </div>
          <div class="input-field col s12">
            <button
              @click="$_confirmClearing(true)"
              class="btn-rounded btn waves-effect white indigo-text text-accent-2 left"
            >
              <i class="material-icons left">arrow_back</i> Resource Centre
            </button>

            <button
              @click="$_confirmSubmission()"
              class="btn-rounded btn waves-effect indigo accent-2 right"
            >
              Submit Your Request <i class="material-icons right">send</i>
            </button>
          </div>
        </div>
      </div>
      <app-bottom-tab />
    </div>
  </div>
</template>
<script>
const schools = [
  "Anse Ger Secondary School, Micoud",
  "Babonneau Secondary School, Babonneau",
  "Bocage Secondary School, Bocage, Castries",
  "Beanfield Comprehensive Secondary School, Vieux Fort",
  "Bonne Terre Preparatory School",
  "Castries Comprehensive Secondary School, Vide Boutielle, Castries",
  "Choiseul Secondary School, La Fargue, Choiseul",
  "Ciceron Secondary School, Ciceron, Castries",
  "Clendon Mason Memorial Secondary School, Dennery",
  "Corinth Secondary School, Corinth, Gros Islet",
  "Entrepot Secondary School, Castries",
  "George Charles Secondary School, Cul de Sac, Castries",
  "Grande Riviere Secondary School, Grande Riviere, Dennery",
  "Gros Islet Secondary School, Beausejour, Gros Islet",
  "International School St. Lucia (private, Canadian), Rodney Heights, Gros Islet",
  "Jon Odlum Secondary School (formerly Marigot Secondary School), Marigot, Castries",
  "Leon Hess Comprehensive Secondary School, Entrepot, Castries",
  "Micoud Secondary School, Micoud",
  "Piaye Secondary School, Piaye, Laborie",
  "Saint Lucia Seventh Day Adventist Academy, Sunny Acres, Castries",
  "St. Joseph's Convent, Cedars, Castries",
  "St. Mary's College, Vigie, Castries",
  "Sir Ira Simmons Secondary School, Vide Boutielle, Castries",
  "Soufriere Comprehensive Secondary School, Soufriere",
  "Vide Bouteille Secondary School, La Clery, Castries",
  "Vieux Fort Comprehensive Secondary School, Vieux Fort",
  "Other",
];
import topNav from "@/components/topNav.vue";
import axios from "axios";
import AppBottomTab from "@/components/AppBottomTab";
export default {
  name: "askAnExpert",
  data() {
    return {
      schools,
      firstMount: true,
      editStatus: false,
      yourNeed: [
        {
          label: "Completing my Climate Change Home Risk Assessment",
          value: "Completing my Climate Change Home Risk Assessment",
        },
        {
          label: "Developing my Adaptation Plan",
          value: "Developing my Adaptation Plan",
        },
      ],
      home_risk_assessment: [
        {
          label: "Home Profile",
          display: false,
          key: "home_profile",
        },
        {
          label: "Wind Hazard Assessment",
          display: false,
          key: "wind_hazard",
        },
        {
          label: "Flood Hazard Assessment",
          display: false,
          key: "flood_hazard",
        },
        {
          label: "Water Shortage Hazard Assessment",
          display: false,
          key: "water_shortage",
        },
        {
          label: "Household Carbon Footprint Calculator",
          display: false,
          key: "house_hold_carbon",
        },
      ],
      adaptation_plan: [
        {
          label: "Wind Hazard",
          display: false,
          key: "wind_hazard",
        },
        {
          label: "Flood Hazard",
          display: false,
          key: "flood_hazard",
        },
        {
          label: "Water Shortage Hazard",
          display: false,
          key: "water_shortage",
        },
        {
          label: "Household Carbon Footprint",
          display: false,
          key: "house_hold_carbon",
        },
      ],
      form: {
        name: "",
        form: "",
        email: "",
        school: "",
        school_other: "",
        contact_number: "",
        help_reason: [],
        risk_assessment: {
          home_profile: "",
          wind_hazard: "",
          flood_hazard: "",
          water_shortage: "",
          house_hold_carbon: "",
        },
        adaptation_plan: {
          home_profile: "",
          wind_hazard: "",
          flood_hazard: "",
          water_shortage: "",
          house_hold_carbon: "",
        },
      },
    };
  },
  components: {
    topNav,
    AppBottomTab,
  },
  beforeRouteLeave(to, from, next) {
    if (this.editStatus) {
      this.$_confirmClearing();
    } else {
      next();
    }
  },
  mounted() {
    this.$_setDefaults();
  },
  watch: {
    hasEdit: function(nV) {
      if (nV && !this.editStatus && !this.firstMount) this.editStatus = true;
      else this.firstMount = false;
    },
  },
  computed: {
    fullNameX: {
      get() {
        return this.$store.state.User.user.name;
      },
    },
    hasEdit: {
      get() {
        return { ...this.form };
      },
    },
    toSubmit: {
      get() {
        return {
          student_name: {
            question: "Student Name",
            answer: this.form.name,
          },
          school: {
            question: "School",
            answer:
              this.form.school !== "Other"
                ? this.form.school
                : this.form.school_other,
          },
          contact_number: {
            question: "Contact Number",
            answer: this.form.contact_number,
          },
          email_address: {
            question: "Email Address",
            answer: this.form.email,
            
          },
          what_do_you_need_help_with: {
            question: "What do you need help with?",
            answer:
              this.form.help_reason.length > 0
                ? `${this.form.help_reason.map((x) => {
                    return `${x}`;
                  })}`
                : "",
          },
          home_risk_assessment: {
            question:
              "If you need help with the Climate Change Home Risk Assessment, pose your question(s) in the space provided in the relevant sections of the Assessment below.",
            answer: this.home_risk_assessment.map((x) => {
              return `${x.label}: ${this.form.risk_assessment[x.key]}`;
            }),
          },
          adaptation_plan: {
            question:
              "If you need help with your Adaptation Plan, pose your question(s) in the space provided that relates to the priority areas you have identified for adaptation projects (or mitigation measures, in the case of your carbon footprint). Before posing your question, provide some background information, including the key vulnerabilities you are trying to address and, in the case of your household carbon footprint, the main factors contributing to your higher than desired energy use.",
            answer: this.adaptation_plan.map((x) => {
              return `${x.label}: ${this.form.adaptation_plan[x.key]}`;
            }),
          },
        };
      },
    },
  },
  beforeDestroy() {
    this.$store.commit("CLEAR_DIALOG");
  },
  methods: {
    $_setDefaults() {
      this.form.name = this.$store.state.User.user.name;
      this.form.email = this.$store.state.User.user.email;
     // this.form.email = 'testuser@gmail.com'
    },
    $_submit(d) {
      let url = `https://sldb.lc/users/expert-question`;
      axios
        .post(url, d)
        .then((e) => {
          console.log(e);
          this.form = {
            name: "",
            form: "",
            email: "",
            school: "",
            school_other: "",
            contact_number: "",
            help_reason: [],
            risk_assessment: {
              home_profile: "",
              wind_hazard: "",
              flood_hazard: "",
              water_shortage: "",
              house_hold_carbon: "",
            },
            adaptation_plan: {
              home_profile: "",
              wind_hazard: "",
              flood_hazard: "",
              water_shortage: "",
              house_hold_carbon: "",
            },
          };
          /*     this.success = true
    this.loading = false */
          // M.toast({ html: `Got it! We'll talk soon :)` });

          let data = {
            title: `Question Submitted`,
            message: `Got it! We'll talk soon :)`,
            //hasImage: '/img/banner-image@2x.cd301ba7.png',
            buttons: [
              {
                id: 0,
                value: "OK",
                action: () => {
                  this.$store.commit("CLEAR_DIALOG");
                },
                close: true,
              },
            ],
            dataType: "",
          };

          this.$store.commit("TRIGGER_DIALOG", { data: data });

          this.editStatus = false;

          /* this.form = {} */
        })
        .catch((err) => {
          /*  this.loading = false */
          M.toast({ html: `O0ps something went wrong please try again later` });
        });
    },
    $_confirmClearing(t) {
      let data = {
        title: `Unsaved data form`,
        message: `Leaving this page before submitting your request will cause you to lose any data entered in the form. `,
        //hasImage: '/img/banner-image@2x.cd301ba7.png',
        buttons: [
          {
            id: 0,
            value: "CANCEL",
            action: () => {
              this.$store.commit("CLEAR_DIALOG");
            },
            close: true,
          },

          {
            id: 1,
            value: "CONFIRM",
            action: () => {
              this.$store.commit("CLEAR_DIALOG");
              this.editStatus = false;
              this.$router.push({ name: "resourceCenter" });
            },
            close: true,
          },
        ],
        dataType: "",
      };

      !this.editStatus
        ? this.$router.push({ name: "resourceCenter" })
        : this.$store.commit("TRIGGER_DIALOG", { data: data });
    },
    $_confirmSubmission() {
      let data = {
        title: `Submit Question`,
        message: `Please ensure you verify your questions/requests before submitting. Click submit to send your request.`,
        //hasImage: '/img/banner-image@2x.cd301ba7.png',
        buttons: [
          {
            id: 0,
            value: "DISMISS",
            action: () => {
              this.$store.commit("CLEAR_DIALOG");
            },
            close: true,
          },

          {
            id: 1,
            value: "SUBMIT",
            action: () => {
              let newData = {};
              let me = Object.keys(this.toSubmit).forEach((x) => {
                let prim = {};
                prim[x];
                Array.isArray(this.toSubmit[x].answer)
                  ? (prim[x] = `${this.toSubmit[x].answer.map((l, c) =>
                      c < 1 ? l : `\n` + l
                    )}`)
                  : (prim[x] = this.toSubmit[x].answer + `\n`);
                Object.assign(newData, prim);
              });
              console.log(newData);
              this.$_submit(newData);
              //  console.log(JSON.stringify(this.toSubmit), this.toSubmit)
              this.$store.commit("CLEAR_DIALOG");
            },
            close: true,
          },
        ],
        dataType: "",
      };
      this.$store.commit("TRIGGER_DIALOG", { data: data });
    },
  },
};
</script>
<style scoped lang="scss">
#askAnExpert {
  .section-title {
    font-size: 26px;
    margin: 16px 0px 2px;
    position: relative;
  }
  .contents-container {
    .content {
      margin: auto;
      text-align: justify;
      max-width: 690px;
      padding: 0 16px 68px;
      //      padding-bottom: 68px;
    }
  }
}
</style>
